<ion-header>
  <ion-toolbar>
    <ion-title>プロフィールの設定</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <!-- ガイダンス：強制感を和らげ、期待感・安心感を伝える -->
  <section class="welcome-section ion-text-center">
    <div class="welcome-icon" aria-hidden="true">
      <ion-icon name="person-circle-outline" color="primary"></ion-icon>
    </div>
    <span class="step-badge">Step 1</span>
    <h2 class="welcome-title">あなたにぴったりの体験を</h2>
    <p class="welcome-lead">ご登録ありがとうございます！</p>
    <p class="welcome-desc text-muted">
      あなたに最適な情報をお届けしたり、他のユーザーとスムーズに交流したりするために、<br
        class="br-sp"
      />
      まずはプロフィールの設定をお願いします。<br />
      完了すると、すべての機能が利用できるようになります。
    </p>
  </section>

  <div class="divider" aria-hidden="true"></div>

  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <!-- 追加設定項目（API: additional_register_items） -->
    @if (isLoadingAdditional) {
    <div class="ion-margin-top ion-text-center">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
    } @else {
    <div class="ion-margin-top">
      @for (item of additionalItems; track item.key) {
      @if (!isBirthdayItem(item)) {
      <ion-card class="additional-item-card ion-no-margin ion-margin-bottom">
        <ion-card-header>
          <ion-card-title class="additional-item-title">
            {{ item.value.label }} @if (item.value.required) {
            <span class="required-mark">必須</span>
            }
          </ion-card-title>
        </ion-card-header>
        <ion-card-content class="additional-item-content">
          @if (item.value.type === 'select') {
          <app-form-select
            [controlName]="item.key"
            [form]="form"
            [options]="getOptions(item.value)"
          ></app-form-select>
          } @else if (item.value.type === 'number') {
          <app-form-input
            [controlName]="item.key"
            [form]="form"
            type="number"
          ></app-form-input>
          } @else if (item.value.type === 'checkbox-list') {
          <div class="checkbox-list-container">
            <ion-list lines="none">
              @for (opt of getCheckboxOptions(item.value); track opt.value) {
              <ion-item class="ion-no-padding">
                <ion-checkbox
                  class="ion-padding-horizontal"
                  [checked]="isCheckboxChecked(item.key, opt.value)"
                  (ionChange)="onCheckboxChange(item.key, opt.value, $event.detail.checked)"
                >
                  {{ opt.label }}
                </ion-checkbox>
              </ion-item>
              }
            </ion-list>
            @if (getFieldError(item.key)) {
            <div class="error-message">{{ getFieldError(item.key) }}</div>
            }
          </div>
          } @else if (item.value.type === 'textarea') {
          <app-form-textarea
            [controlName]="item.key"
            [form]="form"
            [label]="''"
            [placeholder]="'入力してください'"
            [rows]="3"
            [autoGrow]="true"
            [maxlength]="item.value.max || 1000"
          ></app-form-textarea>
          } @else {
          <app-form-input
            [controlName]="item.key"
            [form]="form"
            type="text"
            [maxlength]="item.value.max"
          ></app-form-input>
          }
        </ion-card-content>
      </ion-card>

      @if (isNicknameItem(item)) {
      <ion-card class="additional-item-card ion-no-margin ion-margin-bottom">
        <ion-card-header>
          <ion-card-title class="additional-item-title">
            生年月日
<!--            <span class="required-mark">必須</span>-->
          </ion-card-title>
        </ion-card-header>
        <ion-card-content class="additional-item-content">
          <div class="dob-row">
            <app-form-select
              [form]="form"
              controlName="birthYear"
              [label]="''"
              placeholder="yyyy"
              [required]="true"
              [errors]="{ required: '年は必須です' }"
              [options]="yearOptionsWithPlaceholder"
            ></app-form-select>
            <app-form-select
              [form]="form"
              controlName="birthMonth"
              [label]="''"
              placeholder="mm"
              [required]="true"
              [errors]="{ required: '月は必須です' }"
              [options]="monthOptionsWithPlaceholder"
            ></app-form-select>
            <app-form-select
              [form]="form"
              controlName="birthDay"
              [label]="''"
              placeholder="dd"
              [required]="true"
              [errors]="{ required: '日は必須です' }"
              [options]="dayOptionsWithPlaceholder"
            ></app-form-select>
          </div>
        </ion-card-content>
      </ion-card>
      }
      }
      }

      @if (!hasNicknameAdditionalItem()) {
      <ion-card class="additional-item-card ion-no-margin ion-margin-bottom">
        <ion-card-header>
          <ion-card-title class="additional-item-title">
            生年月日 <span class="required-mark">必須</span>
          </ion-card-title>
        </ion-card-header>
        <ion-card-content class="additional-item-content">
          <div class="dob-row">
            <app-form-select
              [form]="form"
              controlName="birthYear"
              [label]="''"
              placeholder="yyyy"
              [required]="true"
              [errors]="{ required: '年は必須です' }"
              [options]="yearOptionsWithPlaceholder"
            ></app-form-select>
            <app-form-select
              [form]="form"
              controlName="birthMonth"
              [label]="''"
              placeholder="mm"
              [required]="true"
              [errors]="{ required: '月は必須です' }"
              [options]="monthOptionsWithPlaceholder"
            ></app-form-select>
            <app-form-select
              [form]="form"
              controlName="birthDay"
              [label]="''"
              placeholder="dd"
              [required]="true"
              [errors]="{ required: '日は必須です' }"
              [options]="dayOptionsWithPlaceholder"
            ></app-form-select>
          </div>
        </ion-card-content>
      </ion-card>
      }
    </div>
    }

    <app-base-button
      [disabled]="!formValid"
      class="ion-margin-top"
      expand="block"
      type="submit"
    >
      保存
    </app-base-button>
  </form>
</ion-content>
